import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "v-col-6 v-col-md-3" }
const _hoisted_3 = { class: "p-2" }
const _hoisted_4 = { class: "p-2" }
const _hoisted_5 = { class: "p-2" }

import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElButton, ElIcon, ElInput, ElMessage, ElMessageBox, ElRow } from 'element-plus';
    import { useStore } from 'vuex';
    import { Video } from '@/services/types';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import ModalComponent from '@/components/modals/ModalComponent.vue';
    import VideoView from '@/components/modals/views/VideoView.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VideosView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Video[]>([])
    const q = ref<string>('')
    const pages = ref<number>(1)
    const searchType = ref<'string' | 'number'>('string')
    const cod = ref<number>()
    const video = ref<Video | null | undefined | false | 0>(null)

    const getVideos = async (q = '', page = 1) => {
        loading.value = true
        const params = new URLSearchParams()
        params.append('q', q)
        params.append('page', String(page))
        console.log('admin/videos?' + params.toString())
        const res = await Api.get('admin/videos?' + params.toString())
        console.log(res.data.videos)
        if (res.status == 200) {
            pages.value = res.data.videos.last_page
            data.value = res.data.videos.data
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }
    
    const getVideo = async (id: number | undefined) => {
        if (!id || id <= 0) {
            getVideos()
        } else {
            loading.value = true
            pages.value = 1
            q.value = ''
            const res = await Api.get('admin/videos/' + id)
            if (res.status == 200) {
                data.value = [res.data.video]
            } else {
                ElMessage.error('Não foi encontrado nenhum video com este código')
                data.value = []
            }
            loading.value = false
        }
    }

    onBeforeMount(async () => {
        await getVideos()
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 7) {
            // new product
            await getVideos()
        }
    })

    const openVideo = async (id: number) => {
        loading.value = true
        const res = await Api.get('admin/videos/' + id)
        if (res.status == 200) {
            video.value = res.data.video
        } else {
            ElMessage.error('Este video não foi encontrado')
            video.value = null
        }
        loading.value = false
    }

    const deleteVideo = async ({title, id}: {title: string, id: number}) => {
        const yes = confirm(`Deseja realmente eliminar o vídeo ${title} permanentemente?`)
        if (yes) {
            loading.value = true
            const res = await Api.delete(`admin/videos/${id}`)
            if (res.status != 200) {
                ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
                loading.value = false
            } else {
                ElMessage.success({message: title + ' Eliminado'})
                getVideos()
            }
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Vídeos promocionais" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElRow), { class: "py-2" }, {
          default: _withCtx(() => [
            _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "v-col-6 v-col-md-9 me-3" }, "Pesquisar", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_radio_group, {
                modelValue: searchType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    value: "string",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("por título", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: "number",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("Pelo codigo", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        (searchType.value == 'string')
          ? (_openBlock(), _createBlock(_unref(ElRow), {
              key: 0,
              class: "pb-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "search",
                  name: "q",
                  style: {"flex":"1"},
                  modelValue: q.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((q).value = $event)),
                  class: "mx-1",
                  placeholder: "Procurar produtos"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ElButton), {
                  loading: loading.value,
                  onClick: _cache[2] || (_cache[2] = () => getVideos(q.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Search)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(ElRow), {
              key: 1,
              class: "pb-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "number",
                  name: "cod",
                  modelValue: cod.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cod).value = $event)),
                  style: {"flex":"1"},
                  class: "mx-1",
                  placeholder: "Digite o codigo do produto"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ElButton), {
                  disabled: cod.value ? false:true,
                  loading: loading.value,
                  onClick: _cache[4] || (_cache[4] = () => getVideo(cod.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Search)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })),
        _createVNode(PaginatedTable, {
          loading: loading.value,
          height: 450,
          showRows: 10,
          cols: [
                {label: 'Cod', prop: 'id'},
                {label: 'title', prop: 'title'},
            ],
          data: data.value,
          onChange: _cache[5] || (_cache[5] = (p) => getVideos(q.value, p)),
          pages: pages.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Cadastrado por",
              "class-name": "auto",
              "min-width": 200
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(data.row.user?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    icon: "Edit",
                    title: "Editar Info",
                    onClick: () => openVideo(data.row.id)
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_unref(ElButton), {
                    onClick: () => deleteVideo({title: data.row.title, id: data.row.id}),
                    type: "danger",
                    icon: "DeleteFilled",
                    title: "Eliminar"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "data", "pages"])
      ]),
      _: 1
    }),
    (video.value)
      ? (_openBlock(), _createBlock(ModalComponent, {
          key: 0,
          onClose: _cache[7] || (_cache[7] = () => {video.value = null}),
          cardclass: "col-12 col-md-6 col-lg-5 col-x-lg-4",
          header: "Editar informações do vídeo"
        }, {
          default: _withCtx(() => [
            _createVNode(VideoView, {
              video: video.value,
              onUpdate: _cache[6] || (_cache[6] = () => getVideos(q.value))
            }, null, 8, ["video"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})